import { createContext, useRef, useState } from "react";

export const ToolTipContext = createContext(null);

export const ToolTipProvider = ({ children }) => {
  const EXIT_DELAY = 500;
  const [active, setActive] = useState(false);
  const [curId, setCurId] = useState();
  const contents = useRef({});
  const parents = useRef({});
  const timeout = useRef();

  const activate = id => {
    clearTimeout(timeout.current);
    setCurId(id);
    setActive(true);
  };

  const deactivate = () => {
    timeout.current = setTimeout(() => {
      setActive(false);
    }, EXIT_DELAY);
  };

  function registerTooltip(elmRef, content) {
    if (elmRef.current === undefined) {
      console.warn("Tooltip parent element is undefined");
      return false;
    }
    const id = elmRef.current?.getAttribute("id");
    if (id === undefined) {
      console.warn("Tooltip parent element must have an id attribute");
      return false;
    }
    if (content === null) {
      return false;
    }
    contents.current[id] = content;
    parents.current[id] = elmRef;
    return true;
  }

  function getCurrentToolTip() {
    return active && curId && parents.current[curId] && contents.current[curId]
      ? {
          content: contents.current[curId],
          parent: parents.current[curId]
        }
      : false;
  }

  return (
    <ToolTipContext.Provider
      value={{
        activate,
        deactivate,
        registerTooltip,
        getCurrentToolTip
      }}
    >
      {children}
    </ToolTipContext.Provider>
  );
};
